// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_WALL = "P\u0159\u00edsp\u011bvky";
